module.exports = __webpack_public_path__ + "1a2f08118cdd668c27eb4bf1a60bf85e.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/desktop_footer_h380.png
// module id = 239
// module chunks = 0